import { ReactComponent as PlusIcon } from "assets/svgs/plus-icon.svg";
import { Button, Card } from "components";
import { useCallback, useState } from "react";
import styled from "styled-components";
import { TriggerMappingSelect } from "./TriggerMappingSelect";
import { TriggerEntry, TriggerWithName } from "./types";

type Props = {
  value: TriggerEntry[];
  onChange: (trigger: TriggerEntry[] | undefined) => void;
};

export const TriggerMappings = ({ value, onChange }: Props) => {
  const [addingNew, setAddingNew] = useState(false);
  const handleAdd = useCallback(() => {
    setAddingNew(true);
  }, []);

  return (
    <>
      {value.map((trigger, i) => (
        <Card key={trigger.id} size="largish">
          <TriggerMappingSelect
            value={trigger}
            onChange={(changed: TriggerWithName | null) => {
              const next = [...value];
              const index = next.findIndex((n) => n.id === trigger.id);
              if (index === -1) return;

              next.splice(
                i,
                1,
                ...(changed ? [{ id: trigger.id, ...changed }] : [])
              );
              onChange(next);
            }}
          />
        </Card>
      ))}

      {addingNew && (
        <Card size="largish">
          <TriggerMappingSelect
            value={undefined}
            onChange={(trigger: TriggerWithName | null) => {
              if (!trigger) return;

              setAddingNew(false);
              onChange([
                ...value,
                { id: `new-${new Date().getTime()}`, ...trigger },
              ]);
            }}
          />
        </Card>
      )}
      <ButtonWrapper>
        <Button
          withIcon
          noText
          type="button"
          onClick={handleAdd}
          size="largish"
          variant="tertiary"
          disabled={addingNew}
        >
          <PlusIcon />
        </Button>
      </ButtonWrapper>
    </>
  );
};
const ButtonWrapper = styled.div`
  margin-bottom: 20px;
`;
